import React from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import MediumWidthContainer from '../../Layout/Containers/MediumWidthContainer';
import PageHeaderComponent from '../../util/PageHeader/PageHeaderComponent';
import styles from './insurancePage.module.scss';

const OfferingsPageComponent = () => (
    <>
        <PageHeaderComponent heading="Offerings">Insurance Software Offerings</PageHeaderComponent>
        <DefaultWidthContainer>
            <h2 id="core-platform" className={styles.offeringsH2}>
                Core Platform
            </h2>
            <h3 className={styles.offeringsH3}>SIMPLIFY YOUR CORE INFRASTRUCTURE</h3>
            <p className={styles.offeringsText}>
                Noria Insurance Solution is a suite of fully integrated software modules for a truly
                seamless end-to-end policy lifecycle management.
            </p>
            <h3 className={styles.offeringsH3}>UNDERWRITING</h3>
            <p className={styles.offeringsText}>
                Our full quotation and policy administration module covers the entire policy
                lifecycle including endorsements, renewals, commissions, and reinsurance. The system
                handles direct business and business produced by brokers, as well as received co-
                and reinsurance.
                <br />
                <br />
                Setting up new products and insurance object has been made easy thanks to data model
                that is based on a customer/partner relationship. All policies have a defined period
                and are linked to a customer or partner.
            </p>
            <h3 className={styles.offeringsH3}>CLAIMS</h3>
            <p className={styles.offeringsText}>
                Our insurance solutions handle the entire claims process, from the fist notification
                of loss until the claim is closed with a ledger on each claim showing all
                transactions as reserves, payments to claimant, payments to other parties such as
                surveyors and adjusters, and recoveries from reinsurers.
                <br />
                <br />
                Claims are linked to policies - the system automatically identifies policy terms at
                the time of incident. The ledger on each claim shows transactions as:
            </p>
            <ul className={styles.offeringsList}>
                <li>Reserves</li>
                <li>Payments to claimant </li>
                <li>Payments to other parties assurveyors and adjusters etc. </li>
                <li>Recoveries from reinsurers</li>
            </ul>
            <h3 className={styles.offeringsH3}>REINSURANCE</h3>
            <p className={styles.offeringsText}>
                Functionality for co- and reinsurance placing, which handles covers, quota share
                reinsurance, facultative placing (both proportional and non-proportional), and
                umbrella excess of loss programmes.
                <br />
                <br />
                The system can produce the following types of Bordereaux and Statements of Accounts:
                insurance, add (endorsement), closing, claim advice, claims, detailed statements of
                accounts and technical statements of accounts.
            </p>
            <h3 className={styles.offeringsH3}>PERSONAL LEDGER / PAYMENT & BILLING</h3>
            <p className={styles.offeringsText}>
                The personal ledger module keeps track of outstanding payments to and from customers
                and amounts due to and from to reinsurers including functions for reminders,
                collections, and electronic payments.
            </p>
            <h3 className={styles.offeringsH3}>GENERAL LEDGER INTERFACE</h3>
            <p className={styles.offeringsText}>
                General ledger interface transferring premium income, claims costs, debtor, and
                creditor entries to general ledger systems. Flexible setup of accounts and
                accounting dimensions including product, UW year and claim year.
            </p>
        </DefaultWidthContainer>
        <MediumWidthContainer>
            <hr className={styles.offeringsHr} />
        </MediumWidthContainer>
        <DefaultWidthContainer>
            <h2 id="data-reporting" className={styles.offeringsH2}>
                Data Reporting
            </h2>
            <h3 className={styles.offeringsH3}>DATA MODEL</h3>
            <p className={styles.offeringsText}>
                Our optimised data model is purpose-built to best serve the needs for captives,
                marine & energy and brokers. Our customers are provided with the best framework for
                information management to allow efficient interaction between applications for
                business-processes and insight from large pools of data.
                <br />
                <br />
                An application is like a building. Its quality is often based on the foundation. Our
                data model has allowed us to retain our customer for decades, allowing them to speed
                up business process and ensure that key objectives are met. PARIS comes with two
                kinds of code:
            </p>
            <ul className={styles.offeringsList}>
                <li>
                    Setup codes such as agreement type (marine & energy, brokers, captives),
                    business type (direct, co, re) and various forms of statuses
                </li>
                <li>
                    Client codes like division, section, class, product, condition, claim codes,
                    etc.
                </li>
            </ul>
            <p className={styles.offeringsText}>
                We offer the option to set up configurable rules, allowing customers to determine if
                and how different data may act together. PARIS also has its own data dictionary
                (EUSYS) where super-users have access, and a rich help-function for users to find
                table and name for every field shown on screen. All online tables are identified
                with one primary key.
            </p>
            <h3 className={styles.offeringsH3}>DATA WAREHOUSE</h3>
            <p className={styles.offeringsText}>
                The rich data extracted with our report generator allows insurance executives and
                specialists to compare vast datasets with advanced analytics. This drives
                innovation, increase profitability, and improves the ability to deliver the best
                service internally and externally.
                <br />
                <br />
                Prebuilt formulas and standardised features for tasks such as supporting various
                currencies, allows extracting valuable data to be processed in other applications
                used in the business. This empowers insurance experts to make the right decision at
                the right time by transforming raw data to support the required business task.
                <br />
                <br />
                Cutting-edge security mechanisms also serve to ensure the highest level of data
                protection, which is a vital pre-requisite for the insurance industry that handles
                massive amounts of sensitive data.
            </p>
            <h3 className={styles.offeringsH3}>COMPLIANCE</h3>
            <p className={styles.offeringsText}>
                Insurance providers are actively seeking new ways to increase efficiency and improve
                accuracy through initiatives around governance, risk and compliance. These vital
                business processes embed processes, rules and controls to ensure that the business
                operates according to its policies and strategic objectives.
                <br />
                <br />
                PARIS streamlines compliance to reduce risk, control uncertainty and remove manual
                processes across functions and departments in a changing business environment.
            </p>
            <h3 className={styles.offeringsH3}>MANAGEMENT DASHBOARD</h3>
            <p className={styles.offeringsText}>
                PARIS offers decision-makers an updated and visual tool that keeps track on all
                KPIs, metrics and other data used to track real-time business performance. Captives,
                marine & energy and brokers can more efficiently deliver customer value, when silos
                of information are unlocked to provide data insights. By tailoring each client and
                function with unique dashboards, PARIS drives greater efficiency, fewer errors and
                higher profitability.
            </p>
            <h3 className={styles.offeringsH3}>SOLVENCY II REPORTING</h3>
            <p className={styles.offeringsText}>
                PARIS provides “out of the box” compliance for Solvency II reporting. By
                implementing our solution, processes and requirements are easily handled with an
                automated tool that helps with:
            </p>
            <ul className={styles.offeringsList}>
                <li>Financial</li>
                <li>Governance and supervision</li>
                <li>Reporting and disclosure</li>
            </ul>
            <p className={styles.offeringsText}>
                PARIS allows insurers to manage multiple entities and reduce costs with a system
                that is quick to install and easy to use. Our Quick Report module has built-in
                Solvency II reporting capabilities. Data is updated real time, and reports are
                generated in seconds. The parameters of the reports are selected during the
                on-boarding process, but may be fine-tuned at any time. Integrated modules which
                feed data into reports include policy administration, claims management,
                reinsurance, and financial management.
            </p>
        </DefaultWidthContainer>
        <MediumWidthContainer>
            <hr className={styles.offeringsHr} />
        </MediumWidthContainer>
        <DefaultWidthContainer>
            <h2 id="self-service" className={styles.offeringsH2}>
                Self Service
            </h2>
            <p className={styles.offeringsText}>
                When your clients operate 24/7 and have operations on time zones your own customer
                service can not facilitate, the Self Service portal is an ideal solution to
                extending your service capacity.
                <br />
                <br />
                Each carrier can define user access level for clients, which means information
                available on the portal varies by client. Access can be configured to display for
                example information on policy coverage, allow changes to information, file claims
                and much more.
            </p>
        </DefaultWidthContainer>
        <MediumWidthContainer>
            <hr className={styles.offeringsHr} />
        </MediumWidthContainer>
        <DefaultWidthContainer extraStyles={{ paddingBottom: '80px' }}>
            <h2 id="tailored-portals" className={styles.offeringsH2}>
                Tailored Portals
            </h2>
            <p className={styles.offeringsText}>
                In addition to the portals that facilitate your core business processes and extend
                customer service, we can offer you customised portals tailored to your specific
                needs. We can deliver these in a matter of weeks. Contact us to discuss your
                requirements and let us know how we can help you.
            </p>
        </DefaultWidthContainer>
    </>
);

export default OfferingsPageComponent;
